module.exports = __webpack_public_path__ + "static/img/clearing_white_02.0a6e1be0.svg";